export default function CreativeLoginLinks() {
  const links = [
    { website: "Stripe", link: "https://dashboard.stripe.com", gradient: "from-lime-300 to-sky-300" },
    { website: "Evident", link: "https://www.evidentid.com", gradient: "from-purple-300 to-pink-300" },
    { website: "NEXT", link: "https://www.nextinsurance.com", gradient: "from-teal-300 to-blue-300" },
    { website: "Zendesk", link: "https://www.zendesk.com", gradient: "from-orange-300 to-red-300" },
    { website: "Jira", link: "https://www.atlassian.com/software/jira", gradient: "from-yellow-300 to-green-300" },
    { website: "Dropbox", link: "https://www.dropbox.com", gradient: "from-blue-300 to-indigo-300" },
    { website: "Dialpad", link: "https://www.dialpad.com", gradient: "from-cyan-300 to-purple-300" },
    { website: "QuickBooks", link: "https://quickbooks.intuit.com", gradient: "from-red-300 to-orange-300" },
    { website: "Calendly", link: "https://www.calendly.com", gradient: "from-indigo-300 to-lime-300" },
    { website: "Canva", link: "https://www.canva.com", gradient: "from-pink-300 to-yellow-300" },
    { website: "Google", link: "https://play.google.com", gradient: "from-lime-300 to-cyan-300" },
    { website: "Apple", link: "https://www.apple.com/app-store", gradient: "from-purple-300 to-teal-300" },
    { website: "Amazon", link: "https://aws.amazon.com", gradient: "from-orange-300 to-green-300" },
    { website: "Railway", link: "https://railway.app", gradient: "from-yellow-300 to-indigo-300" },
    { website: "MongoDB", link: "https://www.mongodb.com", gradient: "from-blue-300 to-pink-300" },
    { website: "Cloudinary", link: "https://cloudinary.com", gradient: "from-teal-300 to-purple-300" },
    { website: "cPanel", link: "https://cpanel.net", gradient: "from-cyan-300 to-orange-300" },
    { website: "GoDaddy", link: "https://www.godaddy.com", gradient: "from-pink-300 to-red-300" },
    { website: "RankMath", link: "https://rankmath.com", gradient: "from-indigo-300 to-yellow-300" },
    { website: "Zamp", link: "https://zamp.com", gradient: "from-green-300 to-blue-300" },
    { website: "Warmbox", link: "https://www.warmbox.ai", gradient: "from-lime-300 to-purple-300" },
    { website: "MailWiz", link: "https://www.mailwizz.com", gradient: "from-orange-300 to-cyan-300" },
    { website: "ChatGPT", link: "https://chat.openai.com", gradient: "from-teal-300 to-lime-300" },
  ];

  return (
    <div className="p-4 space-y-4">
      <h1 className="text-2xl text-white font-bold mb-6"> Login Links</h1>
      <ul className="space-y-4">
        {links.map((item, index) => (
          <li key={index}>
            <div
              className={`bg-gradient-to-r ${item.gradient} text-black py-4 px-6 text-sm font-medium rounded-lg shadow-md hover:shadow-lg transition-transform transform hover:scale-105`}
            >
              <div className="container mx-auto flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <img
                    src={`https://img.logo.dev/${item.website.toLowerCase()}.com?token=pk_ZExr_MCYTfyxBgUgXtJVkw`}
                    alt={`${item.website} logo`}
                    className="w-8 h-8 rounded"
                  />
                  <span className="font-semibold">{item.website}</span>
                </div>
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-gray-700 transition-colors"
                >
                  Login to {item.website} →
                </a>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
